<template>
    <div class="union-download-guide-bar" :class="{'top': position==1}">
        <img class="btn-close" :src="btnCloseImgUrl" @click="close" v-if="!isSlot && isShowBtnClose">
        <img class="cont-show" :src="contImgUrl" @click="contHandle" v-if="!isSlot">
        <span class="cont-btn" @click="contHandle" v-if="!isSlot && isShowBtnCont">
            <span class="handle">{{btnCont.text}}</span>
        </span>
        <slot v-if="isSlot"></slot>
    </div>
</template>
<script>
export default {
    props: {
        btnCloseImgUrl: { //关闭按钮图片
            type: String,
            default: require("../../assets/images/download/download_guide_bar_btn_close.png")
        },
        contImgUrl: { //内容图片
            type: String,
            default: require("../../assets/images/download/download_guide_bar_club_main.png")
        },
        isShowBtnClose: { //是否显示关闭按钮
            type: Boolean,
            default: true
        },
        contLinkPath: { //内容跳转链接
            type: String
        },
        contLinkParams: { //内容跳转链接参数
            type: Object
        },
        isCustomContHandle: { //是否自定义内容处理方法
            type: Boolean,
            default: false
        },
        isShowBtnCont: { //是否显示内容按钮
            type: Boolean,
            default: true
        },
        btnCont: {
            type: Object,
            default(){
                return {
                    text: "打开"
                }
            }
        },
        isSlot: { //是否自定义插槽内容
            type: Boolean,
            default: false
        },
        position: { //引导条位置: 1:上,2:右,3:下,4:左
            type: Number,
            default: 3
        }
    },
    methods:{
        //关闭
        close(){
            this.$emit("close");
        },
        //内容事件
        contHandle(){
            if(this.isCustomContHandle){
                this.$emit("customHandle");
            } else {
                this.$router.push({
                    path: this.contLinkPath,
                    query: this.contLinkParams
                });
            }
        },
    }
}
</script>
<style>
.union-download-guide-bar{
    width: 100%;
    height: 0.96rem;
    padding: 0;
    margin: 0;
    overflow: hidden;
    background-color: #ffffff;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 10;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
.union-download-guide-bar.top{
    bottom: auto;
    top: 0;
}
.union-download-guide-bar .btn-close{
    flex: 0 0 auto;
    width: auto;
    max-width: 11.6%;
    height: auto;
    max-height: 100%;
}
.union-download-guide-bar .cont-show{
    flex: 0 0 auto;
    width: auto;
    max-width: 88.4%;
    height: auto;
    max-height: 100%;
}
.union-download-guide-bar .cont-btn{
    flex: 1 1 auto;
    margin: 0 0.2rem;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
}
.union-download-guide-bar .cont-btn .handle{
    display: inline-block;
    padding: 0.06rem 0.26rem;
    background-color: #ffffff;
    border: 1px solid #f0861b;
    text-align: center;
    font-size: 0.26rem;
    color: #f0861b;
    line-height: 0.4rem;
}
</style>



// WEBPACK FOOTER //
// src/shared/components/download/download-guide-bar.vue